import {FaSearch, FaTimes} from "react-icons/fa";

export default function SearchToggle({
                                         openSearchToggle,
                                         showSearchToggle,
                                         setOpenSearchToggle,
                                         setShowSearchToggle,
                                         searchCurrency,
                                         setSearchCurrency
                                     }) {

    if (!openSearchToggle) {
        return null
    }
    return (
        <div className={`w-full fixed pt-[130px]  h-[40px] z-20 `}>


            <div className="fixed text-[#808080]   w-full px-4 py-1 transition-all duration-300 ease-out">
                <div className={`relative w-full rounded-xl overflow-hidden transition-all duration-300 ease-out ${
                    showSearchToggle ? "max-h-[200px] opacity-100 " : "max-h-0 opacity-0"
                }`}>
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        <FaSearch className="w-4"/>
                    </div>
                    <input
                        onChange={(e) => setSearchCurrency(e.target.value)}
                        type="text"
                        value={searchCurrency}
                        placeholder="Search active symbols..."
                        className="w-full pl-12 pr-10 py-3  bg-white border border-border rounded-xl text-text-primary placeholder-text-secondary focus:ring-2 focus:border-[0.5px] focus:border-primary focus:ring-primary outline-none transition-all"
                    />
                    <button
                        onClick={() => {
                            setOpenSearchToggle(false);
                            setShowSearchToggle(false)
                        }}
                        className="absolute inset-y-0 right-0 pr-4 flex items-center"
                    >
                        <FaTimes className="text-text-secondary hover:text-text-primary transition-colors"/>
                    </button>
                </div>
            </div>

        </div>
    );
}